<template>
  <v-card class="mt-3 pa-3" style="margin: 15px">
    <form @submit.prevent="gerarRelatorio">
      <div>
        <Select label="Ano" :options="optionsAno" v-model.number="aaletivo" :v="$v.aaletivo" :disabled="loading"/>
        <Select label="Turma" :options="optionsTurma" v-model="cdturma" :v="$v.cdturma" :disabled="loading"/>
        <Select :label="(this.aaletivo >=2020 && this.tipoDeEnsino === 'I') ? 'Campos de Experiência' : 'Disciplina'" :options="optionsDisciplina" v-model.number="cddiscipl" :v="$v.cddiscipl" :disabled="loading"/>
      </div>

      <div style="text-align: right">
        <v-btn width="120px" class="rounded-sm font-weight-regular" type="submit" color="teal" style="color:white" :disabled="loading" :loading="loadingGerar">
          <v-icon size="23" left dark>picture_as_pdf</v-icon>
          Gerar
        </v-btn>
      </div>
    </form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import perfilTurmaReport from '@/reports/professor/perfilTurmaReport';

const TurmasRepository = RepositoryFactory.get('turma');
const DisciplinaRepository = RepositoryFactory.get('disciplina');
const ProfessorReportsRepository = RepositoryFactory.get('professorReports');
const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const defaultSelect = () => ({
  text: '',
  value: '',
});

export default {
  name: 'RelatorioPerfilTurma',
  data() {
    return {
      aaletivo: '',
      cdturma: '',
      cddiscipl: '',
      tipoDeEnsino: '',
      loading: false,
      loadingGerar: false,
      optionsTurma: [defaultSelect()],
      optionsDisciplina: [defaultSelect()],
    };
  },
  validations() {
    return {
      aaletivo: { required },
      cdturma: { required },
      cddiscipl: { required },
    };
  },
  async created() {
    this.aaletivo = this.getAnoAtualServidor;
    await this.loadTurma();
  },
  watch: {
    async aaletivo(newVal, oldVal) {
      this.cdturma = '';
      this.cddiscipl = '-1';
      await this.loadTurma();
    },
    async cdturma(newVal, oldVal) {
      this.cddiscipl = '-1';
      await this.loadDisciplinaPeriodo();
    },
  },
  methods: {
    async loadTurma() {
      if(this.aaletivo === '') { return ; }
      try{
        this.loading = true;
        const { data } = await TurmasRepository.getSelectTurmasPerfil({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo});

        this.optionsTurma = data.results.map(key => ({ text: `${key.nmturma} - ${key.horario}`, value: key.cdturma, tipoDeEnsino: key.cntpensin }));
        this.optionsTurma.unshift(defaultSelect());
      } finally {
        this.loading = false;
      }
    },
    async loadDisciplinaPeriodo() {
      if(this.cdturma === '') { return ; }
       this.tipoDeEnsino = this.optionsTurma[this.optionsTurma.findIndex(element => element.value === this.cdturma)].tipoDeEnsino;
      try {
        this.loading = true;
        const { data } = await DisciplinaRepository.getSelectDisciplinaPerfilPeriodo({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo,
          cdturma: this.cdturma,
        })

        this.optionsDisciplina = data.results.disciplinas.map(key => ({ text: key.dsdiscipl, value: key.cddiscipl }));
        this.optionsDisciplina.unshift({ value: '-1', text: 'Todos' });

      } finally {
        this.loading = false;
      }
    },
    async gerarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      this.loadingGerar = true;
      try {
        const { data } = await ProfessorReportsRepository.getPerfilTurma({
          aaletivo: this.aaletivo,
          cdturma: this.cdturma,
          cddiscipl: this.cddiscipl,
          ...this.userProfessor,
          ...this.school,
        });

        const filtros = {
          nmescola: this.school.nmescola,
          aaletivo: this.aaletivo,
          turma: this.optionsTurma.find(key => key.value === this.cdturma).text,
          //disciplina: this.optionsDisciplina.find(key => key.value === this.cddiscipl).text,
          professores: data.results.professores,
        };

        const docDefinition = await perfilTurmaReport({
          date: data.results.date,
          time: data.results.time,
          filtros,
          data: data.results.perfil,
          tipoDeEnsino: this.tipoDeEnsino,
          indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu,
          anoSubsequente: data.results.configuracao_ano_letivo.fim.substring(0,4), // 2021
        });

        pdfMake.createPdf(docDefinition).download(docDefinition.info.title);
      } finally {
        this.loadingGerar = false;
      }
    },
  },
  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username']),
    optionsAno() {
      if(!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [defaultSelect()];
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
}
</script>

<style>

</style>
